import * as React from "react"
import { Box } from "@mui/material"

import { TitleWithPopover } from "@components"
import ResultsChangeSwitch from "./actions/ResultsChangeSwitch"
import CreateReportButton from "./actions/CreateReportButton";


export default function DigitalShelfTableTitle({ showDiff, onChange }) {
    return <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <TitleWithPopover title={`Digital Shelf KPIs`} />
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', mr: 1 }}>
            <Box sx={{  display: 'flex', mr: 1 }}>
                <ResultsChangeSwitch showDiff={showDiff} onChange={onChange} />
            </Box>
            <CreateReportButton/>
        </Box>
    </Box>
}